const API = {
  ORDERS: "/web/v3/list/main",
  PROFILE: "/web/v3/user/profile",
};

export default API;
